import { render, staticRenderFns } from "./BloqueVideo.vue?vue&type=template&id=3ba5325c"
import script from "./BloqueVideo.vue?vue&type=script&lang=js"
export * from "./BloqueVideo.vue?vue&type=script&lang=js"
import style0 from "./BloqueVideo.vue?vue&type=style&index=0&id=3ba5325c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports